import React from 'react';
import { gettext } from '@eb/i18n';
import noop from 'lodash/noop';

import { CopyField } from '@eb/eds-copy-field';

import { ShareBox } from '@eb/eds-share-box';
import { SHARE_BY_COPY } from './constants';

export class ShareModalContent extends React.Component {
    // TODO: Add prop types

    render() {
        const { shareOptions } = this.props;
        const { eventUrl, eventId, onClick = noop } = shareOptions;

        return (
            <section className="eds-g-cell eds-g-cell-1-1 eds-g-cell--has-overflow">
                <div className="eds-align--center-horizontal eds-l-mar-top-8">
                    <ShareBox {...shareOptions} />
                </div>
                <div className="eds-l-mar-top-8">
                    <CopyField
                        inputFieldId={`event-url-field-${eventId}`}
                        inputFieldStyle="static"
                        label={gettext('Event URL')}
                        value={eventUrl}
                        onCopyClick={onClick.bind(null, SHARE_BY_COPY)}
                    />
                </div>
            </section>
        );
    }
}
